import { keepPreviousData, useQuery } from '@tanstack/react-query';

import OffersService, { ExperienceDealOptionsParams } from '~/services/OffersService';

import { offerQueryKeys } from './useGetOffer';

export function useGetExperienceDealOptions(
  params: ExperienceDealOptionsParams,
  { enabled = true }: { enabled?: boolean } = {},
) {
  return useQuery({
    queryKey: offerQueryKeys.experienceDealOptions(params),
    queryFn: async ({ signal }) => {
      const response = await OffersService.getExperienceDealOptions(params, { signal });
      return response.result;
    },
    enabled: enabled && !!params.deal_sub_category,
    placeholderData: keepPreviousData,
  });
}
